import React from "react";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import Tooltip from "../../../shared/components/common/Tooltip";

const CallerIdParser = ({ callerIdTag, setCallerIdTag, canViewSettings }) => {
  return (
    <div className="bg-white border border-line rounded-2xl p-4 sm:p-6 xl:py-8 shadow-sm h-full">
      <div className="mb-4">
        <h2 className="sm:text-lg font-bold text-primary">Caller ID Parser</h2>
        <p className="text-sm text-mutedLight mt-1">
          Configure how caller ID information is extracted from voicemail email
          messages delivered by your PBX system
        </p>
      </div>

      <div className="mt-6">
        <div className="flex items-center gap-2 mb-2">
          <label className="block text-sm font-medium text-content">
            Caller ID Tag
          </label>
          <Tooltip
            text="Text prepended to caller ID information in email messages for transcription parsing. Adjust this value until the caller ID is parsed correctly. Only the caller ID value is required."
            className={
              "!text-[8px] !font-light !max-w-[200px] !h-auto !whitespace-normal"
            }
          >
            <InfoOutlinedIcon className="text-xs text-slate-400" />
          </Tooltip>
        </div>
        <textarea
          value={callerIdTag}
          onChange={(e) => setCallerIdTag(e.target.value)}
          disabled={!canViewSettings}
          className="w-full px-3 py-2 border border-line rounded-lg text-sm text-content ring-1 ring-primary focus:outline-none focus:ring-1 focus:ring-primary/20 focus:border-primary resize-none placeholder:text-primary disabled:cursor-not-allowed"
          rows={3}
          placeholder="Caller ID: TOLL FREE CALL (555 123-4567)"
        />
        <p className="text-xs text-mutedLight mt-2">
          Example: If your PBX sends "Caller ID: (555) 123-4567", enter "Caller
          ID:".
        </p>
      </div>
    </div>
  );
};

export default CallerIdParser;
